/**
 * Signup draft persistence — survives page refresh across SignupPage and
 * CheckoutPage. Deliberately excludes admin_password: a refresh after email
 * verification re-asks only for the password, nothing else.
 */
const DRAFT_KEY = "axoix_signup_draft";

export interface SignupDraft {
  company_name: string;
  subdomain: string;
  admin_email: string;
  admin_name: string;
  phone: string;
  plan: string;
  referral_code: string;
  primary_vertical: string;
  addon_verticals: string[];
  state: string;
  city: string;
  pincode: string;
  address_line: string;
  address_line_2?: string;
  gstin: string;
  emailVerified: boolean;
  emailVerificationToken: string;
  emailVerificationExpiresAt: number; // Date.now()-style ms timestamp; token is ~30min-lived server-side
}

export function saveSignupDraft(draft: Partial<SignupDraft>): void {
  try {
    const existing = loadSignupDraft() || {};
    const merged = { ...existing, ...draft };
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(merged));
  } catch {
    // sessionStorage unavailable (private browsing, quota) — fail silently,
    // form still works in-memory for the current page load.
  }
}

export function loadSignupDraft(): SignupDraft | null {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    return raw ? (JSON.parse(raw) as SignupDraft) : null;
  } catch {
    return null;
  }
}

export function clearSignupDraft(): void {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
}
